/*
 * Copyright (c) 2023. American Express Company
 */

// third-party
import React from 'react';
import { ButtonPrimary, ButtonSecondary, IconLeft } from '@americanexpress/dls-react';

// models and services
import MixpanelService from 'src/services/mixpanel.service';
import LiteralsService from 'src/services/literals/LiteralsService';
import OnboardingButtonsViewModel from 'src/types/view-models/onboarding/onboarding-buttons.view.model';

// icons and styles
import styles from './OnboardingButtons.module.scss';
import Selectors from 'src/utils/selectors';

export default function OnboardingButtons({
    back,
    backButtonEventName,
    next,
    nextButtonTitle,
    isWideView = false
}: OnboardingButtonsViewModel): JSX.Element {
    const onboardingButtonsStyles: string = isWideView
        ? styles.onboardingButtonsWideView
        : styles.onboardingButtonsDefault;

    return (
        <div className={onboardingButtonsStyles}>
            {back && backButtonEventName && (
                <ButtonSecondary
                    className={styles.backButton}
                    data-cy={Selectors.PlanAhead.BACK_BUTTON}
                    onClick={async () => {
                        MixpanelService.track(backButtonEventName);
                        await back();
                    }}
                >
                    <IconLeft className={styles.icon} />
                    {LiteralsService.getLiteral('Onboarding.back')}
                </ButtonSecondary>
            )}
            {next && nextButtonTitle && (
                <ButtonPrimary
                    className={styles.nextButton}
                    data-cy={Selectors.PlanAhead.NEXT_BUTTON}
                    type="submit"
                    onClick={async () => {
                        await next();
                    }}
                    onKeyUp={async (event: any) => {
                        if (event.keyCode === 13) {
                            // enter key was hit
                            await next();
                        }
                    }}
                >
                    {nextButtonTitle}
                </ButtonPrimary>
            )}
        </div>
    );
}
